// extracted by mini-css-extract-plugin
export default {"customPagination":"styles_customPagination__h0G65"};